import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type {
  TListPartnerBusinessDocumentsParams,
  TListPartnerBusinessDocumentsResponse,
} from "./listPartnerBusinessDocuments.schema";

export const listPartnerBusinessDocuments = (axios: IAxiosInstance) => {
  return async (
    params: TListPartnerBusinessDocumentsParams
  ): Promise<TListPartnerBusinessDocumentsResponse> => {
    const { whiteLabelID } = params;
    const response = await axios.noRetry.get<
      IApiResponse<TListPartnerBusinessDocumentsResponse>
    >(`/api/partners/${whiteLabelID}/business-documents`);
    const resData = response.data;
    if (resData?.success && resData.data) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
